"use strict";

exports.__esModule = true;
exports.formatHour = formatHour;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatHour(value) {
  const hour = (0, _moment.default)(value).format('hh:mm');
  return hour;
}